<template>
  <div v-if="visible" class="game-preparation" :class="[`game-preparation--${kind}`, { 'game-preparation--fading': fading }]" role="status" aria-live="polite">
    <template v-if="kind === 'instruction'">
      <div class="game-preparation__rule-card">
        <span class="game-preparation__eyebrow">Правило дуэли</span>
        <span class="game-preparation__visual">
          <img :src="instructionImage" :alt="mode === 'MOUTH' ? 'Слева рот открыт, справа закрыт' : 'Слева глаза открыты, справа показано моргание'" width="960" height="480" />
        </span>
        <strong class="game-preparation__instruction">{{ mode === 'MOUTH' ? 'Не закрывай рот' : 'Не моргай' }}</strong>
        <span class="game-preparation__rule">{{ mode === 'MOUTH' ? 'Кто закроет —' : 'Кто моргнул —' }} <strong>проиграл</strong></span>
      </div>
    </template>
    <template v-else>
      <span v-if="kind === 'countdown'" class="game-preparation__eyebrow">Приготовься</span>
      <strong :key="kind === 'countdown' ? countdown : kind" class="game-preparation__mark">{{ kind === 'countdown' ? countdown : 'НАЧАЛИ' }}</strong>
    </template>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import blinkImage from "@/assets/img/instruction-blink.webp";
import mouthImage from "@/assets/img/instruction-mouth.webp";
import "@/styles/gamePreparation.css";
const props = defineProps({
  kind: { type: String, default: "" },
  mode: { type: String, default: "BLINK" },
  countdown: { type: Number, default: 3 },
  fading: { type: Boolean, default: false },
});
const instructionImage = computed(() => props.mode === "MOUTH" ? mouthImage : blinkImage);
onMounted(() => {
  // Begin loading during the existing introduction, before the short instruction window.
  for (const src of [blinkImage, mouthImage]) { const image = new Image(); image.src = src; }
});
const visible = computed(() => props.kind === "instruction" || props.kind === "start" ||
  (props.kind === "countdown" && props.countdown <= 3 && props.countdown >= 1));
</script>